import { IconButton, Skeleton, Stack, useMediaQuery } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import { isUndefined } from 'lodash'
import { FC, PropsWithChildren } from 'react'
import { useNavigate } from 'react-router-dom'
import { FINANCES_ROUTE } from '../../constants/routing.constants'
import { useProfileStore } from '../../store/storeProfile'
import { useUserStore } from '../../store/storeUser'
import { useWrapperStore } from '../../store/storeWrapper'
import { theme } from '../../theme'
import { Balance } from '../Balance'
import { OnboardingTooltip } from '../Wrapper/NavigationSidebar/components/OnboardingTooltip'
import WalletAltIcon from './../../assets/icons/WalletAlt.svg?react'

type WrapperProps = PropsWithChildren<{
    isHeaderApp: boolean
    isMobile: boolean
    handelClick: VoidFunction
}>

type Props = {
    isHeaderApp?: boolean
}

const WrapperCoinsEnd: FC<WrapperProps> = ({
    isHeaderApp,
    isMobile,
    handelClick,
    children,
    isStepOnboarding,
}) => {
    const { stepOnboarding } = useWrapperStore((state) => state)

    const Wrapper = ({ children }) => {
        return isStepOnboarding ? (
            <>{children}</>
        ) : (
            <Tooltip title="Пополнение и история платежей" sx={{ display: 'flex' }}>
                {children}
            </Tooltip>
        )
    }

    return (
        <Stack
            spacing={1}
            sx={{
                width: isMobile? '40px': 'auto',
                alignItems: 'center',
                justifyContent:  'center',
                height: '40px',
                backgroundColor: isStepOnboarding ? '#EBF5FD !important' : '#fff',
                borderRadius: '34px',
                p: isHeaderApp ? (isMobile ? '5px' : '6px 14px 6px 12px') : 0,
                '&:hover': {
                    borderRadius: '34px',
                },
            }}>
            {isHeaderApp ? (
                <Wrapper>
                    <Stack
                        onClick={stepOnboarding === 100 ? handelClick: () => {}}
                        direction="row"
                        gap={1}
                        sx={{
                            alignItems: 'center',
                            cursor: stepOnboarding === 100? 'pointer': 'default'
                    }}>
                        <IconButton
                            disabled={stepOnboarding !== 100}
                            id="ButtonFinances"
                            sx={{
                                p: 0,
                                width: '20px',
                                height:' 20px',
                                background: '#fff',
                                color: '#5A5F72',
                            }}>
                            <WalletAltIcon color="#5A5F72" />
                        </IconButton>
                        {children}
                    </Stack>
                </Wrapper>
            ) : (
                children
            )}
        </Stack>
    )
}

export const CoinsEnd: FC<Props> = ({ isHeaderApp = false }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const { stepOnboarding, dialogsOpen } = useWrapperStore((state) => state)
    const { userPersonalData, updateUserPersonalData } = useUserStore()

    const navigate = useNavigate()

    const { balance } = useProfileStore((state) => state)

    if (isUndefined(balance) && !isMobile) {
        return (
            <Skeleton variant="rectangular" width={160} height={40} sx={{ borderRadius: '24px' }} />
        )
    }
    const Wrapper = ({ children }) => (
        <OnboardingTooltip
            placement="bottom-start"
            enterTouchDelay={0}
            open={!isMobile && stepOnboarding === 3}
            title="Коины"
            decription="Мы подарили вам 250 коинов для старта. Баланс можно пополнять, когда понадобится">
            {' '}
            {children}
        </OnboardingTooltip>
    )

    return (
        <Wrapper>
            <WrapperCoinsEnd
                isStepOnboarding={!isMobile && stepOnboarding === 3}
                isHeaderApp={isHeaderApp}
                isMobile={isMobile}
                handelClick={() => navigate(FINANCES_ROUTE)}>
                {(!isMobile || !isHeaderApp) && (
                    <Stack
                        sx={{
                            alignItems: isHeaderApp && !balance ? 'center' : 'left',
                            justifyContent: 'center',
                        }}>
                        <Balance isHeaderApp={isHeaderApp} />
                    </Stack>
                )}
            </WrapperCoinsEnd>
        </Wrapper>
    )
}
